import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_mobile-footer_desktopapp_modalandroid_scan_qr_code_tab-click';

/**
 * Click on “Scan QR Code” tab (Android)
 */
export function trackRetailerMobileFooterDesktopappModalandroidScanQrCodeTabClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
